module.exports = __webpack_public_path__ + "img/prescriptionNum.c64272cd.svg";